import { SipParticipantState, AllParticipantStates } from '../types/roomManager.types';

export const DEFAULT_SIP_STATE: SipParticipantState = {
  connected: false,
  answered: false,
};

export const DEFAULT_PARTICIPANT_STATES: AllParticipantStates = {
  agent: { connected: false },
  customer: { connected: false, answered: false },
};
